var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuntos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 223,
    height: 223,
    viewBox: "0 0 223 223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 223,
    height: 223
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repetir_cuadr\\xEDcula_1",
    "data-name": "Repetir cuadr\\xEDcula 1",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55 -349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-2",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 -349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-3",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35 -349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-4",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65 -349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-5",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95 -349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-6",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 -349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-7",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155 -349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-8",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55 -319)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-9",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -319)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-10",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 -319)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-11",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35 -319)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-12",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65 -319)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-13",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95 -319)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-14",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 -319)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-15",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155 -319)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-16",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55 -289)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-17",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -289)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-18",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 -289)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-19",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35 -289)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-20",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65 -289)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-21",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95 -289)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-22",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 -289)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-23",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155 -289)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-24",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55 -259)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-25",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -259)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-26",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 -259)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-27",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35 -259)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-28",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65 -259)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-29",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95 -259)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-30",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 -259)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-31",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155 -259)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-32",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55 -229)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-33",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -229)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-34",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 -229)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-35",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35 -229)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-36",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65 -229)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-37",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95 -229)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-38",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 -229)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-39",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155 -229)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-40",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55 -199)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-41",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -199)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-42",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 -199)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-43",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35 -199)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-44",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65 -199)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-45",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95 -199)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-46",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 -199)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-47",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155 -199)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-48",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55 -169)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-49",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -169)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-50",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 -169)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-51",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35 -169)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-52",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65 -169)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-53",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95 -169)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-54",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 -169)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-55",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155 -169)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-56",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55 -139)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-57",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -139)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-58",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 -139)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-59",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35 -139)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-60",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65 -139)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-61",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95 -139)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-62",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 -139)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-63",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155 -139)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-64",
    "data-name": "Elipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(55 349)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuntos);
export default __webpack_public_path__ + "static/media/puntos.d72c308a.svg";
export { ForwardRef as ReactComponent };